import { Box } from "@mui/material";

/**
 * Dims a section and blocks interaction while it's showing placeholder data
 * (React Query's previous result, kept on screen while new data loads), so
 * stale content reads as updating and can't be acted on.
 */
export default function PlaceholderFade({ active, children }) {
  return (
    <Box
      sx={{
        opacity: active ? 0.5 : 1,
        pointerEvents: active ? "none" : undefined,
        transition: "opacity 150ms",
      }}
    >
      {children}
    </Box>
  );
}
